// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__20Viy","actionsCol":"EnrolledClinics_actionsCol__3_qK9"};